import { createFileRoute } from "@tanstack/react-router"
import { CalendarPage, CalendarView } from "./-components/CalendarPage"

export interface Search {
  view?: CalendarView
  startDate?: string
  endDate?: string
}

export const Route = createFileRoute("/app/my/calendar/")({
  component: CalendarPage,
  validateSearch: (search: Search) => search,
  beforeLoad: (ctx) => ({
    getTitle: () => ctx.context.t("Calendar"),
  }),
})
